import * as React from 'react';
import { ToolBarContainer } from '../../../../../../designSystem/compositeComponents/ButtonToolBar';
import { TabItem } from '../../../../../../designSystem/Tabber';
import { amorgLocalStorage } from '../../../../../../utils/amorgLocalStorage';
import { WorkplaceAssessmentComponentProps } from '../_components/WorkplaceAssessmentComponentProps';
import { ComparisonReportPanel } from './subReports/ComparisonReportPanel';
import { DetailsReportPanel } from './subReports/DetailsReportPanel';
import { OverviewReportPanel } from './subReports/OverviewReportPanel';
import { Survey, SurveyReport } from '../../../../../../amorg-common';
import { getSurveyStatusLabel } from '../survey/_components/SurveyStatusPanel';
import { SingleColumnLayout } from '../../../../../_layouts/SingleColumnLayout';
import { PageHeader } from '../../../../../../designSystem/PageHeader';
import { Tabber2 } from '../../../../../../designSystem/Tabber2';

export function ReportPanel (props: WorkplaceAssessmentComponentProps & { survey: Survey, surveyReport: SurveyReport; }): JSX.Element 
{
    type ReportTab = 'overview' | 'comparison' | 'details';
    const [selectedTab, setSelectedTab] = React.useState<'overview' | 'comparison' | 'details' | undefined>(undefined);
    const [headerButtons, setHeaderButtons] = React.useState<React.ReactNode>(undefined);

    React.useEffect(() =>
    {
        const key = amorgLocalStorage.surveyReport.viewMode.getKey();
        let viewMode = amorgLocalStorage.surveyReport.viewMode.readOrCreate(key) as ReportTab;
        if (viewMode === 'comparison' && props.survey.segmentations.length === 0)
        {
            amorgLocalStorage.surveyReport.viewMode.write(key, 'overview');
            viewMode = 'overview';
        }
        setSelectedTab(viewMode);
    }, []);

    const tabItems: TabItem[] = [
        { tabName: 'overview', text: 'Overblik' },
        { tabName: 'details', text: 'Detaljevisning' }
    ];

    if ((props.survey?.segmentations || []).length > 0)
    {
        tabItems.splice(1, 0, { tabName: 'comparison', text: 'Sammenligning' });
    }

    return (
        <>
            <PageHeader
                headerText="APV - Rapporter"
                subHeader={getSurveyStatusLabel(props.survey)}
                buttons={
                    <ToolBarContainer>
                        {headerButtons}
                    </ToolBarContainer>
                }
            />

            <SingleColumnLayout>
                <Tabber2 variant='button' alignment='center'
                    selectedTabName={selectedTab}
                    items={tabItems}
                    onClick={tabName =>
                    {
                        setSelectedTab(tabName as 'overview' | 'comparison' | 'details');
                        const key = amorgLocalStorage.surveyReport.viewMode.getKey();
                        amorgLocalStorage.surveyReport.viewMode.write(key, tabName as 'overview' | 'comparison' | 'details');
                    }}
                />

                {selectedTab === 'overview' &&
                    <OverviewReportPanel {...props} setHeaderButtons={setHeaderButtons} />
                }

                {selectedTab === 'comparison' &&
                    <ComparisonReportPanel {...props} setHeaderButtons={setHeaderButtons} />
                }

                {selectedTab === 'details' &&
                    <DetailsReportPanel {...props} setHeaderButtons={setHeaderButtons} />
                }
            </SingleColumnLayout>
        </>
    );
}